module.exports = __webpack_public_path__ + "static/media/ace_of_spades.b9f81c2d.svg";